import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientViewLayer from "../components/ClientViewLayer";

const ClientViewPage = () => {
    return (
        <MasterLayout>
            <ClientViewLayer />
        </MasterLayout>
    );
};

export default ClientViewPage;
